import { useTranslation } from '../../LanguageContext';
import styles from "./ByMe.module.css"
const ByMe=()=>{
    const { t } = useTranslation();
    return <>
    <div className={styles.byMe}>{t.byMe.text} <a  href="https://danielrozenblat.co.il/"  rel="noopener noreferrer" target="_blank" className={styles.a}>{t.byMe.name}</a></div>
    </>
}
export default ByMe
